import { Component, isDevMode, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../views/error-dialog/error-dialog.component';
import { ErrorReportFactory } from '../services/errorReporting/errorReport';
import { ErrorReportingService } from '../services/errorReporting/error-reporting.service';
import { ConfirmDialogComponent } from '../framework/confirm-dialog/confirm-dialog.component';
import { BusyIndicatorComponent } from '../views/shared/busy-indicator/busy-indicator.component';
import { Subject } from 'rxjs';
import { RunConfirmDialogComponent } from '../framework/run-confirm-dialog/run-confirm-dialog.component';
import { InfoDialogComponent } from '../views/info-dialog/info-dialog.component';
import { OkDialogComponent } from '../views/shared/ok-dialog/ok-dialog.component';
import { RunrefineryResponse } from '../model/RunrefineryResponse';
import { RunrefineryRequest } from '../model/RunrefineryRequest';
import { ProgressBusyIndicatorComponent } from '../views/shared/progress-busy-indicator/progress-busy-indicator.component';

@Component({
    selector: 'app-base',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.css'],
    standalone: false
})
export class BaseComponent implements OnInit {
  progressUpdates: RunrefineryResponse[] = [];

  constructor(
    protected errorLogger: ErrorReportingService,
    public matDialog: MatDialog) { }

    private eventSubject = new Subject<any>();

    sendEvent(data: any) {
      this.eventSubject.next(data);
    }
  
    getEvent() {
      return this.eventSubject.asObservable();
    }  


    ngOnInit(): void {
    }

  showBusyDialog(message?: string): MatDialogRef<BusyIndicatorComponent> {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.panelClass = 'busy-dialog';

      dialogConfig.data = {
          message
      };

      return this.matDialog.open(BusyIndicatorComponent, dialogConfig);
  }

  showProgressBusyDialog(message?: string,progressUpdates?: RunrefineryResponse[]): MatDialogRef<ProgressBusyIndicatorComponent> {
      const dialogConfig = new MatDialogConfig();

      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.panelClass = 'busy-dialog';

      dialogConfig.data = {
          message,
          progressUpdates: this.progressUpdates
      };

      return this.matDialog.open(ProgressBusyIndicatorComponent, dialogConfig);
  }

  showConfirmDialog(theTitle: string, msg: string, onClosed?: ((result: boolean) => void),confirmButtonName:string="Confirm", panelClass?: string): void {
    const confirmDialog = this.matDialog.open(ConfirmDialogComponent, {
      panelClass,
      data: {
        title: theTitle,
        message: msg,
        confirmButtonName:confirmButtonName
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      onClosed(result);
    });
  }
  showRunRefineyConfirmDialog(theTitle: string, msg: string, onClosed?: ((result: boolean) => void)): void {
    const confirmDialog = this.matDialog.open(RunConfirmDialogComponent, {
      data: {
        title: theTitle,
        message: msg
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      onClosed(result);
    });
  }


  logError(errorMessage: string, ex: any): void {
    this.errorLogger.submitErrorReport(ErrorReportFactory.newErrorReport(errorMessage, ex));
  }

  displayError(
    errorMessage: string,
    title: string,
    ex?: any,
    onClosed?: ((result?: any) => void) ): void {

    if (ex) {
      this.logError(errorMessage, ex);
    }

    const errorDetails = isDevMode ? ErrorReportFactory.getErrorMessageWithStackTrace(ex) : undefined;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '600px';
    dialogConfig.minWidth = '300px';
    dialogConfig.data = {errorMessage, title, errorDetails};
    dialogConfig.panelClass = 'error-dialog';
    

    this.matDialog.open(ErrorDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe(result => {
        if (onClosed) {
          onClosed(result);
        }
      });
  }

  displayInfo(
    errorMessage: string,
    title: string,
    ex?: any,
    onClosed?: ((result?: any) => void) ): void {

      if (ex) {
        this.logError(errorMessage, ex);
      }
  
      const errorDetails = isDevMode ? ErrorReportFactory.getErrorMessageWithStackTrace(ex) : undefined;
      const dialogConfig = new MatDialogConfig();
  
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.width = '650px';
      dialogConfig.minWidth = '200px';
      dialogConfig.data = {errorMessage, title, errorDetails};
      dialogConfig.panelClass = 'info-dialog';
      
  
      this.matDialog.open(ErrorDialogComponent, dialogConfig)
        .afterClosed()
        .subscribe(result => {
          if (onClosed) {
            onClosed(result);
          }
        });
    }  
  displayWarning(
    errorMessage: string,
    title: string,
    ex?: any,
    onClosed?: ((result?: any) => void) ): void {

    if (ex) {
      this.logError(errorMessage, ex);
    }

    const errorDetails = isDevMode ? ErrorReportFactory.getErrorMessageWithStackTrace(ex) : undefined;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px';
    dialogConfig.minWidth = '200px';
    dialogConfig.data = {errorMessage, title, errorDetails};
    dialogConfig.panelClass = 'warning-dialog';
    

    this.matDialog.open(ErrorDialogComponent, dialogConfig)
      .afterClosed()
      .subscribe(result => {
        if (onClosed) {
          onClosed(result);
        }
      });
  }
  displayInfoHTML(
    errorMessage: string,
    title: string,
    ex?: any,
    onClosed?: ((result?: any) => void) ): void {

      if (ex) {
        this.logError(errorMessage, ex);
      }
  
      const errorDetails = isDevMode ? ErrorReportFactory.getErrorMessageWithStackTrace(ex) : undefined;
      const dialogConfig = new MatDialogConfig();
  
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.width = '650px';
      dialogConfig.minWidth = '200px';
      dialogConfig.data = {errorMessage, title, errorDetails};
      dialogConfig.panelClass = 'info-dialog';
      
  
      this.matDialog.open(InfoDialogComponent, dialogConfig)
        .afterClosed()
        .subscribe(result => {
          if (onClosed) {
            onClosed(result);
          }
        });
    }
    
  showOkDialogWarning(theTitle: string, msg: string, onClosed?: ((result: boolean) => void)): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px';
    dialogConfig.minWidth = '200px';
    dialogConfig.data = {title: theTitle, message: msg};
    dialogConfig.panelClass = 'warning-dialog';
    this.matDialog.open(OkDialogComponent,dialogConfig).afterClosed().subscribe(result => {
      onClosed(result);
    });
  }
  async runRefineryStream(runRefineryRequest: RunrefineryRequest,requestUrl:string): Promise<RunrefineryResponse | null> {
    let finalResponse: RunrefineryResponse | null = null;
    
    const response = await fetch(requestUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(runRefineryRequest)
    });
  
    if (!response.body) {
      throw new Error("No response body from refinery API");
    }
  
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
  
      buffer += decoder.decode(value, { stream: true });
  
      const lines = buffer.split('\n');
      buffer = lines.pop() || ''; // keep last partial line
  
      for (const line of lines) {
        if (line.trim().length === 0) continue;
  
        let msg: RunrefineryResponse;
        try {
          msg = JSON.parse(line) as RunrefineryResponse;
        } catch (err) {
          console.error("Invalid JSON line:", line, err);
          continue;
        }
  
        console.log("Progress update:", msg);
        // Update Angular state
        this.progressUpdates.push(msg);
  
        // The first finished / fatal_error / cancelled is the run's outcome (as in
        // ConfigService.readRunStream). A failed run sends fatal_error and then finished;
        // taking the last message hid the failure.
        if (msg.status === "finished" || msg.status === "fatal_error" || (msg.status as string) === "cancelled") {
          this.progressUpdates = [];
          reader.cancel().catch(() => {});
          return msg;
        }
        if (msg.status === "error") {
          finalResponse = msg;
        }
      }
    }
    return finalResponse;
  }

  getNormalizedDataType(field: string): string {
      if (!field) return "other";
      const type = this.getDataType(field);
  
      if (type === "string") return "string";
      if (type === "boolean") return "boolean";
      if (type === "datetime") return "datetime";
      if (type === "timedelta") return "timedelta";
      if (type === "int" || type === "float") return "number";
  
      return "other";
  }
  getDataType(field: string): string {
    if (!field) return "other";

    const f = field.toLowerCase();
    // ---- STRING ----
    if (["object", "string", "str", "category"].includes(f)) {
      return "string";
    }
    // ---- BOOLEAN ----
    if (["bool", "boolean"].includes(f)) {
      return "boolean";
    }
    // ---- DATETIME ----
    if (f.includes("datetime")) {
      return "datetime";
    }
    // ---- DURATION ----
    if (f.includes("timedelta")) {
      return "timedelta";
    }
    // ---- FLOAT ----
    if (f.includes("float") || f.includes("double")) {
      return "float";
    }
    // ---- INTEGER ----
    if (f.includes("int") || f.includes("uint")) {
      return "int";
    }
    // ---- DEFAULT ----
    return "other";
  }
}
